function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "vscode",
  transform: "translate(0.156 -0.66)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M22.941,3.184,18.01.81a1.491,1.491,0,0,0-1.7.289L.169,15.815a1,1,0,0,0,0,1.475l1.318,1.2a1,1,0,0,0,1.273.057L22.2,3.8a.99.99,0,0,1,1.589.789V4.531A1.5,1.5,0,0,0,22.941,3.184Z",
  transform: "translate(0 -0.002)",
  fill: "#0065a9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-0.156 6.38)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M22.941,77.42l-4.93,2.374a1.491,1.491,0,0,1-1.7-.289L.169,64.788a1,1,0,0,1,0-1.475l1.318-1.2a1,1,0,0,1,1.273-.057L22.2,76.8a.99.99,0,0,0,1.589-.789v.057A1.5,1.5,0,0,1,22.941,77.42Z",
  transform: "translate(0.156 -61.856)",
  fill: "#007acc"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(16.31 0.66)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M177.7,24.318a1.491,1.491,0,0,1-1.7-.289.876.876,0,0,0,1.5-.62V1.716A.876.876,0,0,0,176,1.1a1.491,1.491,0,0,1,1.7-.289l4.93,2.371a1.5,1.5,0,0,1,.847,1.348V20.6a1.5,1.5,0,0,1-.847,1.348Z",
  transform: "translate(-176 -0.66)",
  fill: "#1f9cf0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(-0.156 0.66)",
  opacity: 0.25
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M16.812,24.364A1.49,1.49,0,0,0,18,24.318l4.927-2.371a1.5,1.5,0,0,0,.847-1.348V4.526a1.5,1.5,0,0,0-.847-1.348L18,.807a1.489,1.489,0,0,0-1.7.289L6.868,9.7,2.76,6.583a1,1,0,0,0-1.273.057L.17,7.838a1,1,0,0,0,0,1.475l3.563,3.25L.169,15.813a1,1,0,0,0,0,1.475l1.318,1.2a1,1,0,0,0,1.273.057l4.108-3.118,9.431,8.6A1.488,1.488,0,0,0,16.812,24.364Zm.982-17.233-7.156,5.432L17.794,18Z",
  transform: "translate(0.156 -0.66)",
  fill: "#fff",
  fillRule: "evenodd"
})));

function SvgVscode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.944,
    height: 23.806,
    viewBox: "0 0 23.944 23.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.bd0bafe9.svg";
export { ForwardRef as ReactComponent };